<script>
import { Vue, Component } from 'vue-property-decorator'
import { CARD_HOST, LEGAL_HOST, SUPPORT_PORTAL_LINK_URL, MT_HOST, MK_HOST, TB_HOST } from '@/constants'

@Component
class RulesBase extends Vue {
  host = CARD_HOST
  legalHost= LEGAL_HOST
  supportUrl = SUPPORT_PORTAL_LINK_URL
  mtHost = MT_HOST
  mkHost = MK_HOST
  tbHost = TB_HOST
}

export default RulesBase
</script>
